import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { mutationKeys } from '../api/keys';
import { ApiRequestError } from '../lib/api';

export function isUnauthorized(error: unknown): boolean {
  return error instanceof ApiRequestError && error.status === 401;
}

export function retryUnlessClientError(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiRequestError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export function createAppQueryClient(onUnauthorized: () => void): QueryClient {
  const handleError = (error: Error): void => {
    if (isUnauthorized(error)) onUnauthorized();
  };
  const queryClient = new QueryClient({
    queryCache: new QueryCache({ onError: handleError }),
    mutationCache: new MutationCache({ onError: handleError }),
    defaultOptions: { queries: { staleTime: 30_000, retry: retryUnlessClientError } },
  });
  // The recalculation banner words itself from the latest threshold change, so keep it past the default 5 minutes.
  queryClient.setMutationDefaults(mutationKeys.thresholdChanges, { gcTime: 30 * 60_000 });
  return queryClient;
}
